import React, {useEffect, useState} from "react";
import {useGroup} from "../contexts/GroupContext";
//import LoadingComponent from "../pages/LoadingComponent";
import Grid from "@mui/material/Grid";
import {withStyles} from '@mui/styles';
import Slider from '@mui/material/Slider';
import {firestore} from "../firebase";
import Typography from "@mui/material/Typography";

const VolumeComponent = () => {

    const {group, sendUserInput, selectedSerial} = useGroup() //Get the group and sendUserInput function from the group context
    const [isReady, setIsReady] = useState(false)
    const [currentVolume, setCurrentVolume] = useState(-1);

    const handleVolumeChange = (event, value) => {
        setCurrentVolume(value);
    };

    const handleVolumeSubmit = (event, value) => {
        setCurrentVolume(value);
        sendUserInput("Set volume to " + value)
    };

    //Constructor
    useEffect(() => {
        if (group !== undefined && selectedSerial !== undefined) {
            //Generates listeners on each robots' dialogueHistory collection
            let currentUnsubscriber;
            const generateVolumeListener = async () => {
                const volumeDoc = firestore.collection(`groups/${group}/robots`).doc(selectedSerial)

                //Set the listener to dispatch on added message. Return unsubscriber
                currentUnsubscriber = await volumeDoc.onSnapshot(snapshot => {
                    if (snapshot.data() !== undefined) {
                        setCurrentVolume(snapshot.data().volume)
                    }
                });
            }

            //Generates all basic data needed before rendering
            generateVolumeListener()

            //Cleanup effect
            return () => {
                currentUnsubscriber()
            }
        }
    }, [group, selectedSerial])

    useEffect(() => {
        if (currentVolume !== -1) {
            setIsReady(true)
        }
    }, [currentVolume])

    const HeaderTypography = withStyles((theme) => ({
        root: {
            paddingLeft: theme.spacing(2),
            fontWeight: 'bold',
            textAlign: 'start',
            fontSize: 'large'
        },
    }))(Typography);

    if (isReady) {
        return (
            <>
                <Grid item xs={4}>
                    <HeaderTypography>Zeeno Volume</HeaderTypography>
                </Grid>
                <Grid item xs>
                    <Slider
                        aria-label="Volume"
                        value={currentVolume}
                        onChange={handleVolumeChange}
                        onChangeCommitted={handleVolumeSubmit}
                        valueLabelDisplay="auto"
                        step={1}
                        marks
                        min={0}
                        max={10}
                    />
                </Grid>
            </>
        );
    } else {
        return (<></>);
    }
}

export default VolumeComponent